import axios from '../../../../utills/axiosConfig';

export const fetchMetalColors = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/metal-colors', { params });
  return res.data;
};

export const addMetalColor = async (metalColor) => {
  try {
    const res = await axios.post('/metal-colors', metalColor);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateMetalColor = async (id, metalColor) => {
  console.log('API call - Updating metal color:', id, metalColor);
  const res = await axios.put(`/metal-colors/${id}`, metalColor);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteMetalColor = async (id) => {
  const res = await axios.delete(`/metal-colors/${id}`);
  return res.data;
};

export const importMetalColorCSV = async (formData) => {
  const { data } = await axios.post('/metal-colors/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 